import log from 'salvo-lite/log'

class Payment {
    constructor (components) {
        this._name = this.constructor.name
        this._components = components
    }

    onInit () {
        log.debug(this._name, 'Initializing', this)
        this._nodeSelectors = {
            header: document.querySelector('.section-header'),
            backBtn: document.querySelector('.cancel-link span'),
            iframe: document.querySelector('.payment-form iframe')
        }

        this._insertText()
        this._updateBackButton()
        this._updateIframeStyles()
        log.debug(this._name, 'Initiated', this)
    }

    _insertText () {
        const html = `<p class="payment__text">${window.theme.strings.extraCheckoutMessages.transactionMessage}</p>`
        this._nodeSelectors.header.insertAdjacentHTML('beforeend', html)
    }

    _updateBackButton () {
        this._nodeSelectors.backBtn.innerHTML = window.theme.strings.extraCheckoutMessages.return
    }

    _updateIframeStyles () {
        console.log(this._nodeSelectors.iframe)
        const iframeLabels = this._nodeSelectors.iframe.document.querySelector('label')
        console.log('label', iframeLabels)
    }
}

export default Payment



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Payment.js